<template>
  <div class="loading-container">
    <div class="spinner-wrapper">
      <svg 
        class="spinner" 
        viewBox="0 0 50 50"
      >
        <circle
          class="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke-width="5"
        ></circle>
      </svg>
      <p class="tw-mt-4 tw-text-gray-600 tw-text-center">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    message: {
      type: String,
      default: 'Loading your flow...'
    }
  }
};
</script>

<style scoped>
.loading-container {
  @apply tw-flex tw-items-center tw-justify-center tw-w-full;
}

.spinner-wrapper {
  @apply tw-text-center;
}

.spinner {
  @apply tw-w-16 tw-h-16;
  animation: rotate 2s linear infinite;
}

.spinner .path {
  stroke: #3b82f6;
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
